/*=============================================== CardStyles component ===============================================*/

import { Card, Text } from "tsx-library-julseb"
import classNames from "classnames"

import { Square, Content } from "./styles"
import type { CardStylesProps } from "./types"
import type { ColorItemType } from "components/CardColor/types"

const CardStyles = ({ shadow, radius, spacer }: CardStylesProps) => {
    const { name, variable, css, value } = shadow || radius || spacer

    const items: ColorItemType[] = [
        {
            title: "Variable",
            value: variable,
        },
        {
            title: "CSS",
            value: css,
        },
        {
            title: "Value",
            value: value.toString(),
        },
    ]

    return (
        <Card
            border={{ width: 1 }}
            flexDirection="column"
            alignItems="center"
            gap="s"
            justifyContent={spacer ? "space-between" : "flex-start"}
        >
            <Square
                className={classNames(
                    { "is-shadow": !!shadow },
                    { "is-radius": !!radius },
                    { "is-spacer": !!spacer }
                )}
                style={{
                    ["--square-shadow" as any]: shadow ? css : null,
                    ["--square-radius" as any]: radius ? css : null,
                    ["--square-spacer" as any]: spacer ? css : null,
                    ["--square-width" as any]:
                        radius && name === "Radius Round" ? "100%" : null,
                }}
            />

            <Content alignItems="stretch" flexDirection="column">
                <Text tag="h6">{name}</Text>

                {items.map(({ title, value }) => (
                    <Text key={title}>
                        <Text tag="strong">{title}</Text>: {value}
                    </Text>
                ))}
            </Content>
        </Card>
    )
}

export default CardStyles
